
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {CoachPlayersProfileMatchesListFormUpdate} from "@/models/app/coach/players/profile/matches/list/form/update";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElInputNumber,
  ElSelect,
  ElOption,
  ElDatePicker,
  ElTimeSelect,
  ElButton,
} from "element-plus";
import {Edit} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "match",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElInput,
    ElInputNumber,
    ElSelect,
    ElOption,
    ElDatePicker,
    ElTimeSelect,
    ElButton,
    Edit,
  },
})
export default class CoachPlayersProfileMatchesListFormUpdateIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  match: CoachPlayersProfileMatchesListFormUpdate = new CoachPlayersProfileMatchesListFormUpdate();

  formData: CoachPlayersProfileMatchesListFormUpdate = new CoachPlayersProfileMatchesListFormUpdate();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/common/match/update",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getMatches');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    const fields = [];

    this.match.match_category.content.fields.forEach((fieldMatchCategory: any) => {
      fields.push({
        value: null,
        name: fieldMatchCategory.name,
        property: fieldMatchCategory.property,
      });
    });

    fields.forEach((field: any) => {
      const fieldMatch = this.match.content.fields.filter((item: any) => {
        return item.property === field.property;
      });

      if (fieldMatch.length === 0) {
        this.match.content.fields.push({
          value: null,
          name: field.name,
          property: field.property,
        });
      }
    });

    this.formData = this.match;
  }

  resetFormData(): void {
    this.formData = new CoachPlayersProfileMatchesListFormUpdate();
  }

  updated(): void {
    this.setFormData();
  }
}
